import moment from "moment";
import classNames from "classnames";
import { editIcon, alertRedIcon } from "../../assets/icons";
import { DATE_FORMATS, REGEX } from "../../constants";
import { INTERFACES } from "../organisms/AppDrawers/drawers.constants";

const { DATE_TIME, EMAIL } = INTERFACES;
const { EMAIL: EMAIL_REGEX } = REGEX;

const FieldRenderer = (props, field) => {
  const { value } = props;
  const formattedDate =
    field.meta.interface === DATE_TIME &&
    value &&
    moment.utc(value).format(DATE_FORMATS.DD_MM_YYYY);
  const displayValue = formattedDate || value;

  const isRequiredFieldError = field.meta.isRequired && !value;
  const isEmailFieldError =
    field.meta.interface === EMAIL && value && !EMAIL_REGEX.test(value);
  const hasError = isRequiredFieldError || isEmailFieldError;

  return (
    <div className="group flex h-full  m-auto items-center">
      <span className="truncate ...">{displayValue}</span>
      <img
        src={editIcon}
        alt="edit-icon"
        className={classNames(
          "absolute right-2 top-3 hidden group-hover:block w-4 h-4 cursor-pointer",
          { hidden: hasError }
        )}
      />
      <img
        src={alertRedIcon}
        alt="alert-icon"
        className={classNames(
          "absolute right-2 top-3 hidden w-4 h-4 cursor-pointer",
          { "block": hasError }
        )}
      />
    </div>
  );
};

export default FieldRenderer;
